<template>
    <div
        class="my-3 promotion-card"
        :class="{
            active: promotion.active,
            claimed: promotion.used && !promotion.active
        }"
    >

        <!-- ACTIVE BADGE -->
        <div
            v-if="promotion.active"
            class="active-badge"
        >
            <!-- {{ $t('promotion.active') }} -->
            ACTIVE
        </div>

        <!-- USED OVERLAY -->
        <div
            class="claimed-logo"
            v-if="promotion.used && !promotion.active"
        >
            <img
                src="../../../../assets/used.png"
                alt="Used"
                width="200"
            >
        </div>
        <img
            :src="promotion.image"
            alt="Promotion Image"
            class="promotion-image"
        >
        <div
            class="card-bottom d-flex justify-content-between align-items-center"
            style="position: relative; z-index: 3;"
        >
            <h3 class="title">
                {{ promotion.name }}
            </h3>
            <button
                class="btn detail-btn"
                @click="openOverlay = true"
            >{{ $t('detail') }}</button>
        </div>


        <!-- OVERLAY -->
        <van-overlay
            :show="openOverlay"
            @click="openOverlay = false"
        >
            <div
                class="overlay-wrapper"
                @click.stop
            >
                <div class="detail-card">

                    <!-- CLOSE BUTTON -->
                    <van-icon
                        name="cross"
                        class="close-btn"
                        @click="openOverlay = false"
                    />

                    <h3 class="title mb-2">{{ promotion.name }}</h3>

                    <span v-html="promotion.description"></span>

                    <div class="mb-2">
                        <div class="info-row">
                            <span>{{ $t('promotion.daily_usage_limit') }}</span>
                            <span>{{ promotion.daily_usage_limit ?? 'Unlimited' }}</span>
                        </div>

                        <div class="info-row">
                            <span>{{ $t('promotion.bonus_percent') }}</span>
                            <span>{{ promotion.promotion_percent ?? '-' }} %</span>
                        </div>

                        <div class="info-row">
                            <span>{{ $t('promotion.minimum_turnover_amount') }}</span>
                            <span>{{ promotion.minimum_turn_over_amount ?? '-' }} MMK</span>
                        </div>

                        <div class="info-row">
                            <span>{{ $t('promotion.minimum_withdraw_times') }}</span>
                            <span>{{ promotion.minimum_withdraw_times ?? '-' }}</span>
                        </div>

                        <!-- PROVIDER RESTRICTION BOX -->
                        <div
                            v-if="promotion.providers && promotion.providers.length"
                            class="provider-section"
                        >
                            <div class="restriction-box">
                                <van-icon
                                    name="warning"
                                    class="warning-icon"
                                />
                                <div class="warning-text">
                                    <!-- While this promotion is active, you can <strong>only play</strong> these providers: -->
                                    <span v-html="$t('promotion.warning_text')"></span>
                                </div>
                            </div>

                            <div
                                v-for="provider in promotion.providers"
                                :key="provider.id"
                                class="provider-pill"
                            >
                                {{ provider.name }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    props: {
        promotion: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            openOverlay: false
        }
    },
}
</script>

<style scoped>
.promotion-card {
    position: relative;
    background: #1a183d;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #2b2960;
    box-shadow: 0 4px 14px rgba(0, 0, 0, .35);
    transition: transform 0.25s ease;
}

/* ===== ACTIVE STATE ===== */
.promotion-card.active {
    border: 2px solid #00e676;
    box-shadow:
        0 0 0 2px rgba(0, 230, 118, 0.35),
        0 10px 25px rgba(0, 230, 118, 0.25);
}

.active-badge {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 4;
    background: linear-gradient(135deg, #00e676, #00c853);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 12px;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 10px rgba(0, 230, 118, 0.4);
}

/* ===== CLAIMED / USED ===== */
.promotion-card.claimed::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1;
}

.claimed-logo {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.promotion-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-bottom: 1px solid #2b2960;
}


.provider-section {
    margin-top: 20px;
}

/* Warning box (unchanged) */
.restriction-box {
    background: rgba(255, 193, 7, 0.15);
    border-left: 3px solid #ffc107;
    padding: 10px 12px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.warning-icon {
    color: #ffc107;
    font-size: 18px;
    margin-right: 8px;
}

.warning-text {
    color: #f5f5f5;
    font-size: 14px;
}

/* ==== COMPACT PILL STYLES ==== */
.provider-pill {
    padding: 4px 10px;
    font-size: 12px;
    background: rgba(72, 52, 255, 0.18);
    border: 1px solid #4834ff;
    border-radius: 12px;
    color: #fff;
    display: inline-block;
    margin: 4px;
    white-space: nowrap;
    transition: 0.2s ease;
}

.provider-pill:hover {
    background: rgba(72, 52, 255, 0.3);
    transform: translateY(-1px);
}





.card-bottom {
    padding: 14px 16px;
    z-index: 3;
}

.title {
    color: #fff;
    margin: 0;
    font-weight: 600;
}

.detail-btn {
    background: #4834ff;
    color: #fff;
    border-radius: 6px;
    padding: 6px 14px;
    font-size: 14px;
    border: none;
}

/* ==== INFO ROW ==== */
.info-row {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid #2b2960;
    font-size: 14px;
}

.info-row span:first-child {
    color: #aaa;
}

.info-row span:last-child {
    color: #fff;
}

/* Overlay center */
.overlay-wrapper {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

/* Scrollable card */
.detail-card {
    max-width: 500px;
    background: #202124;
    color: #fff;
    border-radius: 12px;
    padding: 20px;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
}

/* Close icon */
.close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 16px;
    cursor: pointer;
    color: #fff;
}
</style>